import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import 'element-plus/dist/index.css'
import * as echarts from 'echarts'

import Carousel from '../src/common/library.vue'
import './index.css'
import BackToTop from 'vue-backtotop'
//导入图标集合
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import { service } from "@/http/Request"

const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.config.globalProperties.$toArtetails = function (id) {
  const path = `/articleDetail?id=${id}`;
  router.push(path);
};


// 分类列表
app.config.globalProperties.$getCateList = function (id) {
  return new Promise((resolve, reject) => {
    service({
      url:`/article_category/index`,
      method: 'post',
      data:{
        pid:id
      }
    }).then(res => { 
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}


// 对应分类文章列表
app.config.globalProperties.$getList = function (id,key) {
  return new Promise((resolve, reject) => {
    service({
      url:`/article/getList`,
      method: 'post',
      data:{
        cid:id,
        key
      }
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 文章详情
app.config.globalProperties.$getInfo = function (id) {
  return new Promise((resolve, reject) => {
    service({
      url:`/article/getInfo`,
      method: 'post',
      data:{
        id:id
      }
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

app.config.globalProperties.$dateFormat = function (timestamp) {
    var date = new Date(timestamp*1000);
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    
    // 将月份、日期、小时、分钟、秒补0保持两位数格式
    month = month < 10 ? '0' + month : month;
    day = day < 10 ? '0' + day : day;
    
    var dateString = year + '-' + month + '-' + day;
    return dateString;
}



app.config.globalProperties.$echarts = echarts;
app.component('Carousel', Carousel);
app.config.globalProperties.$axios = service;
app.use(ElementPlus, {
  locale: zhCn
})
app.use(store)
app.use(router)
app.use(ElementPlus)
app.use(BackToTop)


app.mount('#app')
